/* ==========================================================================
   GLOBAL — WOODESTAN
   Sticky header, çekmeceler, akordeon, reveal, görsel fallback,
   saçak fiziği, sepet AJAX (istek kuyruğu), tahmini arama.

   Kural: her animasyon .js sınıfına bağlı. Script çalışmazsa içerik görünür
   kalır. Shopify.designMode'da ve prefers-reduced-motion'da hareket kapalı.
   (DEVIR.md §7)
   ========================================================================== */

(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tema ayarları — theme.liquid window.themeConfig olarak basıyor.
     Ayar okunamazsa ikisi de açık kabul edilir. */
  var CFG = window.themeConfig || {};
  var GLASS_SHEEN = CFG.glassSheen !== false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  /* ======================================================================
     1) Header — kaydırınca katılaş, yüksekliği ölç
     ====================================================================== */

  function initHeader() {
    var head = $('[data-head]');
    if (!head) return;

    function measure() {
      document.documentElement.style.setProperty('--head-h', head.offsetHeight + 'px');
    }

    var solid = false;
    function onScroll() {
      var want = window.scrollY > 24;
      if (want === solid) return;
      solid = want;
      /* Şeffaflığı :not(.is-solid) ile duruma bağlamak şart — aksi halde
         template'e bağlı bir kural (0,2,1) .is-solid kuralını (0,2,0) ezer
         ve header sonsuza kadar şeffaf kalır. (DEVIR.md §7) */
      head.classList.toggle('is-solid', solid);
    }

    measure();
    onScroll();
    on(window, 'scroll', onScroll, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(head);
    else on(window, 'resize', measure);
  }

  /* ======================================================================
     2) Çekmeceler — menü, sepet, arama
     ====================================================================== */

  var openDrawer = null;
  var lastFocus = null;

  function drawerOpen(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    if (openDrawer) drawerClose();
    lastFocus = document.activeElement;
    d.hidden = false;
    /* reflow, sonra sınıf → geçiş çalışsın */
    void d.offsetWidth;
    d.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawer = d;
    var focusable = d.querySelector('input:not([type="hidden"]), button, a[href]');
    if (focusable) focusable.focus({ preventScroll: true });
    d.dispatchEvent(new CustomEvent('drawer:open'));
  }

  function drawerClose() {
    var d = openDrawer;
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    var hide = function () { d.hidden = true; };
    window.setTimeout(hide, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function initDrawers() {
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        drawerOpen(opener.getAttribute('data-drawer-open'));
        return;
      }
      if (e.target.closest('[data-drawer-close]')) {
        e.preventDefault();
        drawerClose();
        return;
      }
      /* sepet ikonu: drawer varsa aç, yoksa /cart'a git */
      var cartLink = e.target.closest('[data-cart-open]');
      if (cartLink && $('[data-drawer="cart"]')) {
        e.preventDefault();
        drawerOpen('cart');
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && openDrawer) drawerClose();
      if (e.key !== 'Tab' || !openDrawer) return;
      var items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', openDrawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ======================================================================
     3) Akordeon — mobil menü ve FAQ ortak
     ====================================================================== */

  function initAccordions() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-acc-btn]');
      if (!btn) return;
      var panel = btn.nextElementSibling;
      if (!panel || !panel.hasAttribute('data-acc-panel')) return;

      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');

      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetWidth;
        panel.style.height = '0px';
        window.setTimeout(function () {
          if (btn.getAttribute('aria-expanded') === 'false') { panel.hidden = true; panel.style.height = ''; }
        }, 280);
      } else {
        panel.hidden = false;
        panel.style.height = '0px';
        void panel.offsetWidth;
        panel.style.height = panel.scrollHeight + 'px';
        window.setTimeout(function () {
          if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        }, 280);
      }
    });
  }

  /* ======================================================================
     4) Reveal — 3 sn güvenlik ağı, designMode ve reduced-motion'da kapalı
     ====================================================================== */

  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;

    function showAll() { els.forEach(function (el) { el.classList.add('is-in'); }); }

    if (DESIGN || REDUCED || !window.IntersectionObserver) { showAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    els.forEach(function (el) { io.observe(el); });
    window.setTimeout(showAll, 3000);   /* güvenlik ağı: hiçbir şey gizli kalmasın */
  }

  /* ======================================================================
     5) Görsel fallback — kırık görselde placeholder görünür kalsın
     ====================================================================== */

  function initMediaFallback() {
    function mark(img) {
      var box = img.closest('[data-media]');
      if (box) box.classList.add('media--broken');
    }
    $$('[data-media] img').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) mark(img);
      on(img, 'error', function () { mark(img); });
    });
  }

  /* ======================================================================
     6) Vitrin camı — yansıma imleci takip eder.
        Konum kare başına bir kez, rAF içinde yazılır. İmleç hiç kıpırdamazsa
        hiçbir iş yapılmaz; ekran dışındaki vitrin atlanır.
        reduced-motion'da veya ayar kapalıyken hiç başlamaz: cam sabit kalır,
        sayfa yine tam görünür.
     ====================================================================== */

  function initSheen() {
    if (REDUCED || !GLASS_SHEEN) return;
    var boxes = $$('.vitrine__box');
    if (!boxes.length) return;

    var pending = null, ticking = false;

    function apply() {
      ticking = false;
      var e = pending;
      if (!e) return;
      var vh = window.innerHeight;
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        var r = b.getBoundingClientRect();
        if (r.bottom < -160 || r.top > vh + 160) continue;   /* ekran dışı */
        var x = (e.clientX - r.left) / (r.width || 1);
        var y = (e.clientY - r.top) / (r.height || 1);
        if (x < -0.6) { x = -0.6; }
        if (x > 1.6) { x = 1.6; }
        if (y < -0.6) { y = -0.6; }
        if (y > 1.6) { y = 1.6; }
        b.style.setProperty('--sx', (x * 100).toFixed(1) + '%');
        b.style.setProperty('--sy', (y * 100).toFixed(1) + '%');
      }
    }

    on(window, 'pointermove', function (e) {
      pending = e;
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
  }

  /* ======================================================================
     7) Sepet — AJAX ekleme, istek kuyruğu, drawer yenileme
     ====================================================================== */

  var chain = Promise.resolve();
  function enqueue(fn) {
    chain = chain.then(fn).catch(function () {});
    return chain;
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function refreshCartUI() {
    return fetch(ROOT + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer="cart"]');
        var cur = $('[data-drawer="cart"]');
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          var wasHidden = cur.hidden;
          cur.innerHTML = fresh.innerHTML;
          cur.hidden = wasHidden;
          if (wasOpen) cur.classList.add('is-open');
        }
        var c = doc.querySelector('[data-cart-total-count]');
        if (c) setCartCount(c.getAttribute('data-cart-total-count'));
      });
  }

  function showFormError(form, msg) {
    /* Hatayı ÖNCE ürün formuna yaz. Sepet drawer'ındaki hedefe yazınca
       müşteri ürün sayfasında hiçbir şey olmamış sanıyor. (DEVIR.md §7) */
    var box = form ? form.querySelector('[data-form-msg]') : null;
    if (!box) box = $('[data-cart-msg]');
    if (!box) { window.alert(msg); return; }
    box.textContent = msg;
    box.className = 'form-msg form-msg--err';
  }

  function initCart() {
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('[data-form-msg]');
      if (msg) msg.textContent = '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-busy'); }

      enqueue(function () {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              showFormError(form, res.data.description || res.data.message || 'Could not add to cart.');
              return;
            }
            return refreshCartUI().then(function () { drawerOpen('cart'); });
          })
          .catch(function () { showFormError(form, 'Network error. Please try again.'); })
          .then(function () {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-busy'); }
          });
      });
    });

    /* miktar değiştir / satır sil */
    on(document, 'click', function (e) {
      var el = e.target.closest('[data-cart-change]');
      if (!el) return;
      e.preventDefault();
      var line = el.getAttribute('data-line');
      var qty = el.getAttribute('data-cart-change');
      enqueue(function () {
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
        })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCartUI(); });
      });
    });
  }

  /* ======================================================================
     8) Tahmini arama
     ====================================================================== */

  function initSearch() {
    var input = $('[data-psearch-input]');
    var out = $('[data-psearch-results]');
    if (!input || !out) return;

    var timer, ctrl;
    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      if (q.length < 2) { out.innerHTML = ''; return; }

      timer = setTimeout(function () {
        ctrl = new AbortController();
        var url = ROOT + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var body = doc.querySelector('[data-psearch-body]');
            out.innerHTML = body ? body.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ======================================================================
     Başlat
     ====================================================================== */

  function boot() {
    initHeader();
    initDrawers();
    initAccordions();
    initReveal();
    initMediaFallback();
    initSheen();
    initCart();
    initSearch();
  }

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', boot);
  else boot();

  /* tema editöründe bölüm yeniden yüklenince tekrar bağla */
  on(document, 'shopify:section:load', function () {
    initReveal();
    initMediaFallback();
    initSheen();
  });
})();
